module.exports = "/img/_/_/_/assets/images//background.png?3cdd408d64b1ad637b97b98888de69d3";